export const uuidv4 = () => {
  return "xxxxxxxxxxxxxxxxxxxx".replace(/[x]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
